import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { VideoSize } from '../types/instance';

export const useVideoSize = () => {
    const instance = usePlayerInstance();
    const [videoSize, setVideoSize] = useState<VideoSize | undefined>(() => instance?.videoSize);

    useInstanceEffect((instance) => instance.onVideoSizeChange(setVideoSize));

    return videoSize;
};
